/**
 * Shared `useMe` query hook. Returns the current user + tenant in one
 * round-trip (sc-platform's `/api/me` endpoint). Cached under a stable
 * key so every consumer in the app shares the same result.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiRequest } from '../lib/apiClient.js';
import { queryKeys } from '../lib/queryKeys.js';
import { meResponseSchema } from '../lib/schemas.js';
import type { MeResponse } from '../lib/types.js';

export const useMe = (): UseQueryResult<MeResponse, Error> =>
  useQuery<MeResponse>({
    queryKey: queryKeys.me(),
    // Validated at the boundary — /api/me gates portal + assistant access.
    queryFn: () => apiRequest<MeResponse>('/api/me', undefined, meResponseSchema),
  });
